import { useState } from 'react';
import { cn } from '../lib/utils';
import {
  WhatsAppSettings,
  ShopifySettings,
  WidgetSettings,
  BusinessBriefingSettings,
  ContactSettings,
  LocationsSettings,
  FeedbackSettings,
  NotificationSettings,
  AiResponsibilitiesSettings,
} from '../features/settings';
import IntegrationSettings from '../features/settings/components/IntegrationSettings';
import { VoiceSettings } from '../features/voice';

const tabs = [
  { id: 'notifications', label: 'Notifications' },
  { id: 'contact', label: 'Contact Info' },
  { id: 'locations', label: 'Locations' },
  { id: 'briefing', label: 'Business Briefing' },
  { id: 'responsibilities', label: 'AI Responsibilities' },
  { id: 'whatsapp', label: 'WhatsApp' },
  { id: 'voice', label: 'Voice' },
  { id: 'feedback', label: 'Feedback' },
  { id: 'integrations', label: 'Integrations' },
  { id: 'shopify', label: 'Shopify' },
  { id: 'widget', label: 'Web Widget' },
] as const;

type TabId = (typeof tabs)[number]['id'];

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState<TabId>('notifications');

  return (
    <div className="mx-auto max-w-4xl p-6">
      <div className="mb-6">
        <h1 className="font-display text-2xl font-bold text-ink">Settings</h1>
        <p className="mt-1 text-sm text-ink-2">
          Configure your integrations and business settings
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="mb-6 border-b border-line">
        <nav className="-mb-px flex gap-6 overflow-x-auto scrollbar-thin">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                'shrink-0 whitespace-nowrap border-b-2 py-3 text-sm font-medium transition-colors',
                activeTab === tab.id
                  ? 'border-brand text-brand'
                  : 'border-transparent text-ink-3 hover:border-line-2 hover:text-ink'
              )}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === 'notifications' && <NotificationSettings />}
      {activeTab === 'contact' && <ContactSettings />}
      {activeTab === 'locations' && <LocationsSettings />}
      {activeTab === 'briefing' && <BusinessBriefingSettings />}
      {activeTab === 'responsibilities' && <AiResponsibilitiesSettings />}
      {activeTab === 'whatsapp' && <WhatsAppSettings />}
      {activeTab === 'voice' && <VoiceSettings />}
      {activeTab === 'feedback' && <FeedbackSettings />}
      {activeTab === 'integrations' && <IntegrationSettings />}
      {activeTab === 'shopify' && <ShopifySettings />}
      {activeTab === 'widget' && <WidgetSettings />}
    </div>
  );
}
